import { render, staticRenderFns } from "./ImageUploadCard.vue?vue&type=template&id=d260baca&scoped=true"
import script from "./ImageUploadCard.vue?vue&type=script&lang=js"
export * from "./ImageUploadCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d260baca",
  null
  
)

export default component.exports